import { render, staticRenderFns } from "./Socks.vue?vue&type=template&id=3c481df3&scoped=true"
import script from "./Socks.vue?vue&type=script&lang=js"
export * from "./Socks.vue?vue&type=script&lang=js"
import style0 from "./Socks.vue?vue&type=style&index=0&id=3c481df3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c481df3",
  null
  
)

export default component.exports